import React, { useState } from 'react';
import './ConfirmEditLofaSchedule.scss';
import Modal from 'react-bootstrap/Modal';
import ModalHeaderTitle from '../../../AddLoads/ModalHeaderTitle';
import { CustomButton } from '../../../_common';
import { CustomLofaButton } from '../../../_common/CustomLofaButton/CustomLofaButton';
import { useStoreContext } from '../../../App/StoreProvider';
import { LofaDetailByProppantEdit, LofaScheduleSummaryObject } from '../../../../store/types/LofaScheduleEditState';
import {
    EditType,
    EditInfo,
    ProppantInfo,
    LOFAAddOrDeletion,
} from '../../../../interfaces/JobProfile/ConfirmModalInterfaces';
import ConfirmModalItem from '../../../../components/_common/ConfirmModalItem';

const proppantEditMap = new Map<string, any>();

const deletedOrAddedLofa = (
    proppantId: number | null,
    proppantName: string | null,
    lofaName: string,
    lofaVolume: number | undefined,
    milesFromWell: number | undefined,
    maxVolumeBox: number | undefined,
    sandPo: string,
    transportationPo: string,
    editType: EditType,
): void => {
    if (proppantId === null) return;
    const newLofaEdit: LOFAAddOrDeletion = {
        lofaName: lofaName,
        lofaVolume: lofaVolume,
        milesFromWell: milesFromWell,
        maxVolumeBox: maxVolumeBox,
        sandPo: sandPo,
        transportationPo: transportationPo,
        editType: editType,
    };
    if (proppantEditMap.has(proppantId.toString())) {
        proppantEditMap.get(proppantId.toString()).addOrDeletions.push(newLofaEdit);
    } else {
        const newProppantInfo: ProppantInfo = {
            proppantId: proppantId,
            title: proppantName,
            edits: [],
            addOrDeletions: Array(newLofaEdit),
        };
        proppantEditMap.set(proppantId.toString(), newProppantInfo);
    }
};

const changedAttributes = (
    proppantId: number | null,
    proppantName: string | null,
    attribute: string,
    editType: EditType,
    oldValue: any,
    newValue: string | number,
): void => {
    if (proppantId === null) return;
    const newProppantEdit: EditInfo = {
        attributeName: attribute,
        oldValue: oldValue,
        newValue: newValue,
        editType: editType,
    };
    if (proppantEditMap.has(proppantId.toString())) {
        proppantEditMap.get(proppantId.toString()).edits.push(newProppantEdit);
    } else {
        const newProppantInfo: ProppantInfo = {
            proppantId: proppantId,
            title: proppantName,
            edits: Array(newProppantEdit),
            addOrDeletions: [],
        };
        proppantEditMap.set(proppantId.toString(), newProppantInfo);
    }
};

const compareJobSummaries = (oldProppant: LofaScheduleSummaryObject, newProppant: LofaDetailByProppantEdit): void => {
    const newProppantsJobSummaries = newProppant.jobSummaries.filter(item => item.lofaName != '');
    const oldProppantsJobSummaries = oldProppant.jobSummaries;
    newProppantsJobSummaries.map(newJobSummary => {
        if (oldProppantsJobSummaries === undefined || oldProppantsJobSummaries === null) return;
        const oldJobSummary = oldProppantsJobSummaries.find(oldJobSummary => {
            if (oldJobSummary === undefined || oldJobSummary === null) return false;
            return oldJobSummary.jobSummaryId === newJobSummary.jobSummaryId;
        }) as any;
        if (newJobSummary['isDeleted']) {
            deletedOrAddedLofa(
                oldProppant.proppantId,
                oldProppant.proppantName,
                newJobSummary.lofaName,
                newJobSummary.lofaVolume,
                newJobSummary.milesFromWell,
                newJobSummary.volumePerBox,
                newJobSummary.sandPo,
                newJobSummary.transportationPo,
                EditType.LOFA_DELETE,
            );
        } else if (newJobSummary['jobSummaryId'] === 0 && newJobSummary['isDeleted'] === false) {
            deletedOrAddedLofa(
                oldProppant.proppantId,
                oldProppant.proppantName,
                newJobSummary.lofaName,
                newJobSummary.lofaVolume,
                newJobSummary.milesFromWell,
                newJobSummary.volumePerBox,
                newJobSummary.sandPo,
                newJobSummary.transportationPo,
                EditType.LOFA_ADDED,
            );
        } else {
            Object.entries(newJobSummary).forEach(([newJobSummaryKey, newJobSummaryValue]) => {
                if (oldJobSummary === undefined || oldJobSummary === null || newJobSummaryKey === 'lofaId') return;
                const oldJobSummaryValue = oldJobSummary[newJobSummaryKey];
                if (oldJobSummaryValue !== newJobSummaryValue) {
                    changedAttributes(
                        oldProppant.proppantId,
                        oldProppant.proppantName,
                        newJobSummaryKey,
                        EditType.LOFA_INFO,
                        oldJobSummaryValue,
                        newJobSummaryValue,
                    );
                }
            });
        }
    });
};

const prepareLofaScheduleEdits = (
    pumpScheduleSummaryList: LofaScheduleSummaryObject[],
    toBePosted: LofaDetailByProppantEdit[],
): void => {
    toBePosted.map(newProppant => {
        const oldProppant = pumpScheduleSummaryList.find(
            oldProppant =>
                oldProppant.proppantId === newProppant.proppantId ||
                oldProppant.proppantName === newProppant.proppantName,
        );
        Object.entries(newProppant).forEach(([newProppantKey]) => {
            if (oldProppant === undefined || oldProppant === null) return;
            if (newProppantKey === 'jobSummaries') {
                compareJobSummaries(oldProppant, newProppant);
                return;
            }
        });
    });
};

const getEditComponents = (): React.ReactElement[] => {
    const components: React.ReactElement[] = [];
    let index = 0;

    proppantEditMap.forEach((value, key) => {
        const editObject = value as ProppantInfo;
        if (editObject !== undefined && editObject.edits !== undefined && editObject.title !== null) {
            const proppantInfoEdits = editObject.edits.filter(edit => edit.editType === EditType.LOFA_INFO);

            if (proppantInfoEdits.length > 0) {
                index = index + 1;
                components.push(
                    <ConfirmModalItem
                        index={index}
                        key={key + index}
                        title={editObject.title.toString()}
                        editType={EditType.LOFA_INFO}
                        edits={proppantInfoEdits}
                    ></ConfirmModalItem>,
                );
            }
        }

        if (editObject !== undefined && editObject.addOrDeletions !== undefined && editObject.title !== null) {
            const lofaInfoDelete = editObject.addOrDeletions.filter(edit => edit.editType === EditType.LOFA_DELETE);
            const lofaInfoAdd = editObject.addOrDeletions.filter(edit => edit.editType === EditType.LOFA_ADDED);
            if (lofaInfoDelete.length > 0) {
                index = index + 1;
                components.push(
                    <ConfirmModalItem
                        index={index}
                        key={key + index}
                        title={editObject.title}
                        editType={EditType.LOFA_DELETE}
                        lofaAddOrDeletions={lofaInfoDelete}
                    ></ConfirmModalItem>,
                );
            }

            if (lofaInfoAdd.length > 0) {
                index = index + 1;
                components.push(
                    <ConfirmModalItem
                        index={index}
                        key={key + index}
                        title={editObject.title}
                        editType={EditType.LOFA_ADDED}
                        lofaAddOrDeletions={lofaInfoAdd}
                    ></ConfirmModalItem>,
                );
            }
        }
    });
    return components;
};

interface ConfirmEditLofaScheduleProps {
    lofaScheduleSummaryList: LofaScheduleSummaryObject[];
    onEditSave: () => void;
}

const ConfirmEditLofaSchedule = ({
    onEditSave,
    lofaScheduleSummaryList,
}: ConfirmEditLofaScheduleProps): React.ReactElement => {
    const [state] = useStoreContext();
    const { lofaScheduleEdit } = state;
    const { toBePosted, isFormDisabled } = lofaScheduleEdit;

    const [show, setShow] = useState(false);
    const handleClose = (): void => {
        proppantEditMap.clear();
        setShow(false);
    };
    const handleContinue = (): void => {
        proppantEditMap.clear();
        onEditSave();
    };

    const isDisabled = (): boolean => {
        let pageDisabled = false;
        if (toBePosted) {
            toBePosted.map(item => {
                if (item) {
                    if (item !== null && item.proppantId !== null) {
                        item.jobSummaries.forEach(jobSummary => {
                            let rowError = false;
                            if (jobSummary) {
                                const rowIsDeleted = jobSummary.isDeleted !== undefined && jobSummary.isDeleted;
                                if (!rowIsDeleted) {
                                    rowError =
                                        jobSummary.lofaVolume === undefined ||
                                        jobSummary.milesFromWell === undefined ||
                                        jobSummary.volumePerBox === undefined ||
                                        jobSummary.lofaVolume === null ||
                                        jobSummary.milesFromWell === null ||
                                        jobSummary.volumePerBox === null ||
                                        jobSummary.lofaVolume <= 0 ||
                                        jobSummary.milesFromWell <= 0 ||
                                        jobSummary.volumePerBox <= 0 ||
                                        jobSummary.lofaName === '' ||
                                        jobSummary.sandPo === '' ||
                                        isFormDisabled;
                                } else {
                                    rowError = false;
                                }
                            } else {
                                rowError = true;
                            }
                            if (rowError) {
                                pageDisabled = true;
                            }
                        });
                    } else {
                        pageDisabled = true;
                    }
                } else {
                    pageDisabled = true;
                }
            });
        }

        if (toBePosted === undefined) {
            pageDisabled = false || isFormDisabled;
        }

        return pageDisabled;
    };

    return (
        <React.Fragment>
            <CustomLofaButton
                isBordered={false}
                title="Save"
                onClick={() => {
                    prepareLofaScheduleEdits(lofaScheduleSummaryList, toBePosted);
                    setShow(true);
                }}
                validate={lofaScheduleEdit}
                disabled={isDisabled()}
            />
            {proppantEditMap.size > 0 && (
                <Modal show={show} onHide={handleClose} scrollable size="lg">
                    <Modal.Header className="ConfirmEditLofaSchedule-Header">
                        <Modal.Title className="ConfirmEditLofaSchedule-Header-Container">
                            <ModalHeaderTitle
                                title={'Edit LOFA Schedule Confirmation Summary'}
                                onCancelClick={() => {}}
                            ></ModalHeaderTitle>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="ConfirmEditLofaSchedule-Body">{getEditComponents()}</Modal.Body>
                    <Modal.Footer className="ConfirmEditLofaSchedule-Footer">
                        <CustomButton title="Cancel" isBordered onClick={handleClose}></CustomButton>
                        <CustomButton title="Continue" onClick={handleContinue}></CustomButton>
                    </Modal.Footer>
                </Modal>
            )}
        </React.Fragment>
    );
};

export default ConfirmEditLofaSchedule;

